<template>

<app-page>

	<app-page-head :title="title" back="Locations">

		<template v-if="$permission('edit')">

			<app-page-head-action :disabled="!isDirty" icon="undo" tooltip="Undo changes" v-on:click.native="onUndoClick" />
			<app-page-head-action :loading="is.saving" :disabled="!isDirty" icon="save" tooltip="Save changes" v-on:click.native="onSaveClick" />
			<app-page-head-action route="Location.Delete" v-if="!isNew && $canDelete" :disabled="isNew" :danger="true" icon="delete" tooltip="Delete" />

		</template>
		
	</app-page-head>

	<app-page-content :is-grown="true">

		<app-page-content-section :is-padded="true" is-divided="!isNew" :grow="true">

			<app-input-text v-model="model.title" :validation="$v.model.title" label="Title" placeholder="Enter title" :maxlength="64" />
			<app-input-toggle v-model="model.flag" :validation="$v.model.flag" label="Flagged" />
			<app-input-slug v-model="model.slug" :validation="$v.model.slug" :source="model.title" label="Slug" placeholder="Enter slug" :maxlength="64" />
			<app-input-image v-model="model.logo" :validation="$v.model.logo" label="Logo/Icon" />
			<app-input-text v-model="model.map" :validation="$v.model.map" label="Map embed" placeholder="Enter embed code" :autogrow="true" :notes="mapNotes" />
			<app-input-text v-model="model.label" label="Distance label" placeholder="e.g. Event, Mail-in" :maxlength="32" notes="Shown in the app in place of the distance, for locations without a map." />
			<app-input-toggle v-model="model.services" label="Services" :stacked="true" :options="$constants.locationServices" :multiple="true" />
			<app-input-tags v-model="model.terms" :dynamic-tag="model.title" label="Terms" />
			<app-input-toggle v-model="model.format" label="Content" :full-width="true" :options="contentOptions" />
			<app-input-select v-model="model.template" label=" " :validation="$v.model.template" placeholder="No template" :full-width="true" :options="templateOptions" v-if="model.format === 1" />

		</app-page-content-section>

		<app-page-content-section :is-padded="true" is-divided="true" :grow="true">

			<app-input-texts v-model="model.texts" :is-legacy="true" store="locations" route="Location.Text" v-if="model.format === 0" />

			<app-input-section v-model="model.content" v-if="model.format === 1" />

		</app-page-content-section>

		<app-page-content-link v-if="!isNew" is-divided="true" icon="groups" title="Groups" route="Location.Groups" :params="{location: model.id}" :count="useCount" />

	</app-page-content>

	<app-page-foot />

</app-page>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, maxLength, minValue, minLength } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			contentOptions: {
				0: 'v1',
				1: 'v2'
			},
			model: {
				id: 0,
				slug: '',
				logo: '',
				flag: 0,
				title: '',
				template: 0,
				format: 0,
				map: '',
				label: '',
				content: [],
				terms: [],
				texts: [],
				services: []
			},
			param: 'location',
			noun: 'Location',
			store: 'locations',
			data: {},
			callbacks: [
				'textRemove',
				'textDelete',
				'textInsert',
				'textReplace'
			]
		}

	},

	validations: function() {

		var validations = {
			model: {
				title: {
					required,
					maxLength: maxLength(64)
				},
				slug: {
					required
				},
				logo: {
					required
				},
				map: {
					
				},
				services: {
					minLength: minLength(1)
				}
			}
		}

		if (this.model.format === 2) {

			validations.model.template = {
				required,
				minValue: minValue(1)
			}

		}

		return validations

	},

	watch: {

		template: function(n) {

			if (this.is.loading) return

			if (n) {

				var template = this.$_.findWhere(this.data.templates, {
					id: n
				})

				if (template) {
					
					this.model.content = template.content

				} else {

					this.model.content = []

				}

			} else {

				this.model.content = []

			}

		}

	},

	computed: {

		mapNotes: function() {

			if (!this.model.id) return false

			var saved = this.$store.getters['locations/find'](this.model.id)

			if (!saved || !saved.map) return false

			if (saved.multiple) return 'Embed shows multiple locations — the app will display "Multiple locations" instead of a distance.'

			if (saved.lat !== null && saved.lat !== undefined) return 'Coordinates detected: ' + saved.lat + ', ' + saved.lng

			return 'No coordinates could be detected in this embed, so the app won\'t show a distance for it.'

		},

		template: function() {

			return this.model.template

		},

		templateOptions: function() {

			var templates = {
				0: 'No template'
			}

			this.$_.each(this.data.templates, function(template) {

				templates[template.id] = template.name

			})

			return templates

		},

		useCount: function() {

			var locationId = this.model.id
			var uses = 0

			this.$_.each(this.$store.getters['groups'], function(group) {

				var matched = false

				this.$_.each(group.texts, function(id) {

					var text = this.$_.findWhere(this.$store.getters['texts'], {
						id: id
					})

					if (text) {

						if (text.location === locationId) matched = true

					}

				}.bind(this))

				if (!matched && group.format) {

					this.$_.each(group.content, function(section) {

						if (section.enabled) {

							this.$_.each(section.blocks, function(block) {

								if (block.enabled && block.location && !matched) {

									matched = block.location === locationId

								}

							}.bind(this))

						}

					}.bind(this))

				}

				if (matched) uses++

			}.bind(this))

			return uses

		},

		texts: function() {

			return this.$store.getters['texts/find/index'](this.model.texts)

		},

		watchTexts: function() {

			return this.model.texts

		}

	},

	methods: {

		load: function() {

			this.is.loading = true

			return this.$api.get(['location', this.$route.params.location]).then(function(response) {

                this.$vueset(this, 'data', this.$util.clone(response))

				this.is.loading = false

			}.bind(this))

		},

		textRemove: function(id) {

			this.model.texts.splice(this.model.texts.indexOf(id), 1)

		},

		textInsert: function(e) {

			this.model.texts.splice(e.position, 0, e.id)

		},

		textReplace: function(e) {

			this.model.texts[this.model.texts.indexOf(e.from)] = e.to

		},

		textDelete: function(id) {

			this.model.texts.splice(this.model.texts.indexOf(id), 1)
			if (this.original.texts.indexOf(id) !== -1) this.original.texts.splice(this.original.texts.indexOf(id), 1)

		}

	}

}

</script>

<style scoped>

</style>
